// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"143b258b","102":"c84d510a","899":"25440c70"}[chunkId] + ".chunk.css";
};